import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import React, { useMemo } from "react";
import { ItemData } from "@api/useItemDetails";
import { FaRegCircleDown } from "react-icons/fa6";
import Button from "@components/Button";
import HighlightExperience from "./HighlightExperience";
import LikesAndDislikes from "./LikesAndDislikes";
import { useItemAiOpenEndsReport } from "@api/useItemAiOpenEndsReport";

const CardOpenEndedFeedback: FCX<{
    data: ItemData;
}> = ({
    className,
    data,
}) => {
    const {
        id,
        aiTopLikes,
        aiTopDislikes,
        responsesLike,
        responsesDislike,
        conceptPersonalQuestions,
        topicsBaseSize,
        highlightsBaseSize,
    } = data;

    const report = useItemAiOpenEndsReport(id ?? 0);

    const {
        likeAnswers: rawLikeAnswers,
        dislikeAnswers: rawDislikeAnswers,
    } = conceptPersonalQuestions || {};

    const hasLikesAndDislikesData = useMemo(
        () => (
            ((aiTopLikes ?? []).length > 0) ||
            ((aiTopDislikes ?? []).length > 0) ||
            ((rawLikeAnswers ?? []).length > 0) ||
            ((rawDislikeAnswers ?? []).length > 0)
        ),
        [aiTopLikes, aiTopDislikes, rawLikeAnswers, rawDislikeAnswers]
    );

    const hasHighlightingData = useMemo(
        () => (
            ((responsesLike ?? []).length > 0) ||
            ((responsesDislike ?? []).length > 0)
        ),
        [responsesLike, responsesDislike]
    );

    return (
        <div className={cn('card', 'CardOpenEndedFeedback', className)}>
            <div className="card-header CardOpenEndedFeedback__header">
                <div className="CardOpenEndedFeedback__header-inner">
                    OPEN ENDED FEEDBACK
                    <Button
                        modifiers={['green']}
                        className="font-bold"
                        onClick={report.load}
                        style={{ position: 'relative', overflow: 'hidden', width: 140 }}
                        isDisabled={report.isLoading}
                    >
                        {report.isLoading ? (
                            <>
                                Downloading...
                                <div className="ProgressLoader is-inside-button"/>
                            </>
                        ) : (
                            <>
                                <FaRegCircleDown className="icon" style={{ width: 20, height: 20 }}/>
                                &nbsp;DOWNLOAD
                            </>
                        )}
                    </Button>
                </div>
            </div>
            <div className="card-content">
                {hasLikesAndDislikesData && (
                    <LikesAndDislikes
                        likeTopics={aiTopLikes ?? []}
                        dislikeTopics={aiTopDislikes ?? []}
                        likeOpenEnds={rawLikeAnswers ?? []}
                        dislikeOpenEnds={rawDislikeAnswers ?? []}
                        baseSize={topicsBaseSize ?? 0}
                    />
                )}
                {hasHighlightingData && (
                    <HighlightExperience
                        likes={responsesLike ?? []}
                        dislikes={responsesDislike ?? []}
                        baseSize={highlightsBaseSize ?? 0}
                    />
                )}
            </div>
        </div>
    )
};

export default CardOpenEndedFeedback;